import "./SchoolsListing.css";
import { PulseLoader } from "react-spinners";
import SchoolsListingViewModel from "./SchoolsListingViewModel";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import { Avatar } from "@mui/material";
import { StringAvatar } from "../../../../Helpers/StringAvatar";

const SchoolsListing = () => {
  const { SchoolObject, AuthUser, IsLoading } = SchoolsListingViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper student-school-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Schools</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/${AuthUser?.UserType}/dashboard`}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Schools</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Schools</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>HOD</th>
                            <th>Started Year</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {SchoolObject?.SchoolLogo !== "" ? (
                                <img
                                  className="school-logo"
                                  src={SchoolObject?.SchoolLogo}
                                  alt=""
                                />
                              ) : (
                                <Avatar
                                  className="string-avatar"
                                  {...StringAvatar(SchoolObject?.SchoolName)}
                                />
                              )}
                            </td>
                            <td>{SchoolObject?.SchoolName}</td>
                            <td>{SchoolObject?.SchoolEmail}</td>
                            <td>{SchoolObject?.SchoolAddress}</td>
                            <td>{SchoolObject?.HeadOfSchool}</td>
                            <td>{SchoolObject?.SchoolStartDate}</td>
                          </tr>
                        </tbody>
                      </table>
                      {Object.keys(SchoolObject).length === 0 && (
                        <NoDataFound />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default SchoolsListing;
